import { useEffect, useState } from 'react';

interface Props {
  onDone: () => void;
}

export function SplashScreen({ onDone }: Props) {
  const [phase, setPhase] = useState<'hidden' | 'visible' | 'fading'>('hidden');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('visible'), 60);
    const t2 = setTimeout(() => setPhase('fading'), 1900);
    const t3 = setTimeout(() => onDone(), 2400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [onDone]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-brand"
      style={{
        opacity: phase === 'fading' ? 0 : 1,
        transition: phase === 'fading' ? 'opacity 0.5s ease-out' : 'none',
      }}
    >
      <div
        className="flex flex-col items-center gap-8 px-8"
        style={{
          opacity: phase === 'visible' ? 1 : 0,
          transform: phase === 'visible' ? 'translateY(0)' : 'translateY(16px)',
          transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
        }}
      >
        {/* Logo bus */}
        <img
          src="/new_assets/Logo_Sogpred.svg"
          alt="Logo idaNroh"
          className="w-36 h-auto md:w-44"
          draggable={false}
        />

        {/* Wordmark */}
        <img
          src="/new_assets/Idainroh.svg"
          alt="idainroh"
          className="w-56 h-auto md:w-64"
          draggable={false}
        />

        {/* Tagline */}
        <p className="font-display text-sm text-white/70 text-center leading-relaxed max-w-[260px] md:max-w-xs">
          Le créneau le moins chargé pour avoir une place sans faire la queue.
        </p>
      </div>
    </div>
  );
}
